import styled from 'styled-components'
import { respondTo } from '../../../styles/_respondTo'


export const SkillsContainer = styled.div`
  padding: 10px;
  margin-bottom: 30px;
  border-bottom: 1px solid rgb(92, 96, 105);

  ${respondTo.lg`
    gap: 20px;
  `}

  ${respondTo.xl`
  `}
`
export const Skills = styled.div`
  display: grid;
  gap: 40px;
  

  ${respondTo.xs`
    
  `}

  ${respondTo.sm`
  `}

  ${respondTo.md`
  `}

  ${respondTo.lg`
  grid-auto-flow: column;
  padding: 0;
  padding-bottom: 50px;
  gap: 0 30px;
  
  `}

  ${respondTo.xl`
  `}

`
export const imgSkill = styled.img`
  width: 40px;
  height: 60px;

`

